import React from "react";
import isEqual from "lodash-es/isEqual";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { findIconDefinition as faDef } from "@fortawesome/fontawesome-svg-core";

export const Fa = React.memo(FontAwesomeIcon, isEqual);
Fa.displayName = FontAwesomeIcon.name;
export const findIconDefinition = faDef;
